import Head from "next/head";
import { useEffect } from "react";
import { wrapper } from "@/redux/Store";

import YogaFaqPage from "@/containers/StaticPages/YogaFAQPage";
import YogaFaqsPageForApp from "@/containers/StaticPages/FaqsPageForApp";
import { appendFreshChatScript } from "../../utils/Scripts/index"

const YogaFaq = ({ isAppPage }: { isAppPage: boolean }) => {

  useEffect(() => {
    appendFreshChatScript()
  },[])

  return (
    <>
      <Head>
        <title>Shyft</title>
      </Head>
      <main>{isAppPage ? <YogaFaqsPageForApp /> : <YogaFaqPage />}</main>
    </>
  );
};

export default YogaFaq;

export const getServerSideProps = wrapper.getServerSideProps(
  () =>
    async ({ query }) => {
      const { source } = query || {};

      let isAppPage = false;
      if (typeof source === "string" || typeof source === "undefined") {
        isAppPage = source?.toLowerCase() === "app";
      } else {
        source.forEach((value) => {
          if (value.toLowerCase() === "app") {
            isAppPage = true;
            return;
          }
        });
      }

      return { props: { isAppPage } };
    }
);
